import { OTHER_CKBX_VAL } from "./OtherCheckboxUtils";

export const PLATFORM_BUTTONS = [ 
  {
    value: 'windows',
    label: 'Windows computer',
    moreInfo: ''
  },
  {
    value: 'mac',
    label: 'Mac computer',
    moreInfo: ''
  },
  {
    value: 'iphone',
    label: 'Apple iPhone',
    moreInfo: ''
  },
  {
    value: 'android-phone',
    label: 'Android smartphone',
    moreInfo: ''
  },
  {
    value: 'ipad',
    label: 'iPad tablet',
    moreInfo: ''
  },
  {
    value: 'android-tablet',
    label: 'Android tablet',
    moreInfo: ''
  },
  {
    value: 'chromebook',
    label: 'Chromebook',
    moreInfo: ''
  },
  {
    value: OTHER_CKBX_VAL,
    label: 'Other',
    moreInfo: ''

  }
];

